<h2 mat-dialog-title class="w-100 text-center">{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  <div class="w-100 pb-4">
    <!--div>Current High Bid: {{bpSpreadData.auction.highestBidAmount | currency:'USD':'symbol':'1.2-2'}}</div-->
    <div>Current Reserve: {{bpSpreadData.clientReserve | currency:'USD':'symbol':'1.2-2'}}</div>
    <!--div>Bid Increment: {{bpSpreadData.auction.increment | currency:'USD':'symbol':'1.2-2'}}</div-->
    <form [formGroup]="reserveCreditForm" class="flex-col mt-3">
      <mat-radio-group aria-label="Select an option" formControlName="reservePriceOption" >
        <div class="flex-col w-100">
          <mat-radio-button [value]="1" [checked]="reserveCreditForm.controls.reservePriceOption.getRawValue()==1" ><span>Full BP Buy Down Reserve: <b>{{bpSpreadData.minimumReserve | currency:'USD':'symbol':'1.2-2'}}</b></span></mat-radio-button>
          <mat-radio-button [value]="2" [checked]="reserveCreditForm.controls.reservePriceOption.getRawValue()==2" ><span>Next Bid Meets Reserve: <b>{{bpSpreadData.reserveMetNextBid | currency:'USD':'symbol':'1.2-2'}}</b></span></mat-radio-button>
          <div class="flex-row items-center w-100">
            <mat-radio-button [value]="3" [checked]="reserveCreditForm.controls.reservePriceOption.getRawValue()==3">Custom Value:</mat-radio-button>
            @if(reserveCreditForm.controls.reservePriceOption.getRawValue()===3){ 
              <mat-form-field appearance="outline" class="mt-4 ml-2 flex-1">
                <input matInput autocomplete="off" formControlName="reservePrice" type="number" [min]="bpSpreadData.reserveMetNextBid" [max]="bpSpreadData.clientReserve" required>
                @if (reserveCreditForm.get('reservePrice')!.errors?.['required']) {<mat-error class="w-100">Value is required</mat-error>}
                @if (reserveCreditForm.get('reservePrice')!.errors?.min) {<mat-error class="w-100">Value cannot be lower than {{bpSpreadData.reserveMetNextBid | currency:'USD':'symbol':'1.2-2'}}</mat-error>}
                @if (reserveCreditForm.get('reservePrice')!.errors?.max) {<mat-error class="w-100">Value cannot be higher than {{bpSpreadData.clientReserve | currency:'USD':'symbol':'1.2-2'}}</mat-error>}
              </mat-form-field>
            }
          </div>
          @if(reserveCreditForm.controls.reservePriceOption.getRawValue()===3){ 
            <mat-hint >Value cannot be less than current high bid plus increment.</mat-hint>
          }
        </div>
      </mat-radio-group>
      
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions >
  <div class="flex-row spce-between items-center w-100 mt-3">
    <button [disabled]="!canSubmit" mat-flat-button class="w-50" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
    <button [disabled]="!canCancel" mat-flat-button class="w-50" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>

